import { IntegrationType, AllowedOrderType } from "src/graphql/quark/quark.type"

export const INTEGRATION_TYPE_OPTIONS = Object.values(IntegrationType).map((type) => ({
  value: type,
  label: type
}))

export const ORDER_TYPE_OPTIONS = Object.values(AllowedOrderType).map((type) => ({
  value: type,
  label: type
}))

export const INTEGRATION_STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
  { value: "PENDING", label: "Pending" },
  { value: "ERROR", label: "Error" }
]
